import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from './globalAction';

export const setMetadataDatasets = (Year) => {
    return (dispatch) => {
        var Session = JSON.parse(localStorage.getItem("SessionLogin"));
        var isAgency = false;
        Session?.Roles.map((item, index) => {
            if(item.IdRole == 2 || item.IdRole == 4){
                isAgency = false;
            } else {
                isAgency = true;
            }
        })
        if(isAgency){
            var URL = `${URLSVC}/Admins/GetMetadatas?Year=${Year}&AgencyCode=${Session?.Agency.Code}`;
        } else {
            var URL = `${URLSVC}/Admins/GetMetadatas?Year=${Year}`;
        }
        http.get(URL).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                const Datas = [];
                data.Data.map((item,index) => {
                    if(item.Status == "Approve" && item.Priority == "Priority"){
                        Datas.push(item);
                    }
                })
                dispatch({type: 'DATA_PRIORITASS', payload: Datas})
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDatasets = (MetadataId) => {
    return (dispatch) => {
        var Session = JSON.parse(localStorage.getItem("SessionLogin"));
        http.get(`${URLSVC}/Admins/GetDatasets?MetadataId=${MetadataId}&UserId=${Session?.IdUser}`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                console.log(data.Data);
                dispatch({type: 'DATASETS', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormDataset = (formType, formValue) => {
    return {type: 'FORM_DATASET', formType, formValue}
}

export const apiSaveUploadDataset = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();
        const Url = `${URLSVC}/Admins/UploadDataset`;
        fd.append('Id', iData.Id);
        if(iData.UrlName !== null){
            fd.append('UrlName', iData.UrlName);
        }
        fd.append('FileUpload', iData.FileUpload[0]);
        http.post(Url,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil upload dataset`, 'success');
                dispatch({ type: 'MODAL_UPLOAD', payload: false })
                dispatch(setDatasets(iData.MetadataId))
                reset()
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiSaveApproveDataset = (iData,reset) => {
    return (dispatch) => {
        var Proses = "";
        var Url = "";
        if(iData.IsApprove){
            Proses = "menyetujui";
            Url = `${URLSVC}/Admins/ApproveDataset`;
        } else if(iData.IsApprove == undefined || iData.IsApprove == false){
            Proses = "me-reject";
            Url = `${URLSVC}/Admins/RejectDataset`;
        }
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan ${Proses} data (${iData.Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', iData.Id);
                if(iData.FileUpload !== undefined){
                    fd.append('FileUpload', iData.FileUpload[0]);
                }
                fd.append('Note', iData.Note);
                http.post(Url,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil ${Proses} data (${iData.Title})`, 'success')
                        dispatch(setDatasets(iData.MetadataId))
                        dispatch({ type: 'MODAL_APPROVE', payload: false })
                        reset();
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiCancelApproveDataPrioritas = (Id, MetadataId, Nama, Year) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan membatalkan approval data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/SetCancelApprove`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil membatalkan approval data (${Nama})`, 'success')
                        dispatch(setDatasets(MetadataId))
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}